import { Card } from "antd";
import dayjs from "dayjs";
import { useLocation, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import ReviewLeavePopup from "../UI/PopUp/ReviewLeavePopup";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";

const DetailLeave = () => {
	const { state } = useLocation();
	const leave = state?.leaveData;

	// console.log("LeaveData", leave);


	return (
		<div>
			<PageTitle title='Back' />
			<Card className='mt-4'>
				<div className='text-center mb-4'>
					{" "}
					<h2 className='text-2xl font-semibold text-gray-600'>
						Leave Application #{leave?.EmployeeLeaveId}{" "}
					</h2>
				</div>
				{leave ? (
					<div className='flex justify-center '>
						<ul className='list-inside list-none border-2 border-inherit rounded px-5 py-5 '>
							<ListItem>
								Name :{" "}
								<TextInside>
									{(leave?.EmployeeName)
										? (leave.EmployeeName).toUpperCase()
										: "User information not available"}
								</TextInside>

							</ListItem>
							<ListItem>
								Leave Type : <TextInside>{leave?.LeaveTypeName}</TextInside>
							</ListItem>
							<ListItem>
								Leave From:{" "}
								<TextInside>
									{dayjs(leave.StartDate).format("YYYY-MM-DD")}
									{leave.IsCustom && leave.StartDateDayTypeName
										? ` (${leave.StartDateDayTypeName})`
										: ""}
								</TextInside>
							</ListItem>


							<ListItem>
								Leave To :{" "}
								<TextInside>
									{dayjs(leave.EndDate).format("YYYY-MM-DD")}
									{leave.IsCustom && leave.EndDateDayTypeName
										? ` (${leave.EndDateDayTypeName})`
										: ""}
								</TextInside>
							</ListItem>

							<ListItem>
								Leave Applied:{" "}
								<TextInside >
									{leave.LeaveInDays} {leave.LeaveInDays <= 1 ? "Day" : "Days"}
								</TextInside>
							</ListItem>

							{/* <ListItem>
									Leave Reason :{" "}
									<TextInside>{leave.reason || "No reason"}</TextInside>
								</ListItem> */}

							<ListItem>
								Leave Status :{" "}
								<TextInside>
									{leave.LeaveStatusName === "Pending" ? (
										<span className='text-yellow-500'>
											{leave.LeaveStatusName.toUpperCase()}
										</span>
									) : leave.LeaveStatusName === "Approved" ? (
										<span className='text-green-500'>
											{leave.LeaveStatusName.toUpperCase()}
										</span>
									) : (
										<span className='text-red-500'>
											{leave?.LeaveStatusName?.toUpperCase()}
										</span>
									)}
								</TextInside>
							</ListItem>

							<ListItem>
								{leave.LeaveStatusName === "Approved"
									? "Leave Approved From"
									: leave.LeaveStatusName === "Rejected"
										? "Leave Rejected From"
										: "Leave Approval Pending"}:{" "}
								<TextInside>
									{leave.ApprovedStartDate
										? dayjs(leave.ApprovedStartDate).format("DD-MM-YYYY")
										: "ON REVIEW"}
								</TextInside>
							</ListItem>


							<ListItem>
								{leave.LeaveStatusName === "Approved"
									? "Leave Approved To"
									: leave.LeaveStatusName === "Rejected"
										? "Leave Rejected To"
										: "Leave Approval Pending"}:{" "}
								<TextInside>
									{leave.ApprovedEndDate
										? dayjs(leave.ApprovedEndDate).format("DD-MM-YYYY")
										: "ON REVIEW"}
								</TextInside>
							</ListItem>

							<ListItem>
								Leave Approved:{" "}
								<TextInside className='text-green-500'>
									{leave?.ApprovedLeaveInDays} {leave?.ApprovedLeaveInDays <= 1 ? "Day" : "Days"}
								</TextInside>
							</ListItem>


							{/* <ListItem>
								Leave Accepted By :{" "}
								<TextInside className='text-green-500'>
									{leave.ApprovedByName}
									 {(leave.acceptLeaveBy?.firstName || "ON") +
											" " +
											(leave.acceptLeaveBy?.lastName || "REVIEW")} 
								</TextInside>
							</ListItem> */}
							<ListItem>
								{leave.LeaveStatusName === "Approved"
									? "Leave Approved By"
									: leave.LeaveStatusName === "Rejected"
										? "Leave Rejected By"
										: "Approval Pending From"}:{" "}
								<TextInside className='text-green-500'>
									{leave.ApprovedByName || "ON REVIEW"}
								</TextInside>
							</ListItem>


							<ListItem>
								Review Comment :{" "}
								<TextInside>{leave.reviewComment || "No comment"}</TextInside>
							</ListItem>

							<ListItem>
								Attachment :{" "}
								<TextInside>
									{leave.attachment ? (
										<a
											href={leave.attachment}
											target='_blank'
											rel='noreferrer'
											className='text-blue-500'>
											Download
										</a>
									) : (
										"No Attachment"
									)}
								</TextInside>
							</ListItem>
						</ul>
					</div>
				) : (
					<Loader />
				)}
				{leave?.LeaveStatusName === "Pending" && (
					<div className='flex justify-center items-center'>
						<ReviewLeavePopup leaveId={leave?.EmployeeLeaveId} leaveData={leave} />
					</div>
				)}
			</Card>
		</div>
	);

	// "reviewComment": null,
	// "attachment": null,
};

const ListItem = tw.li`
text-sm
text-gray-600
font-semibold
py-2
px-4
bg-gray-100
mb-1.5
rounded
w-96
flex
justify-start
`;

const TextInside = tw.p`
ml-2
text-sm
text-gray-900
`;
export default DetailLeave;
